import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SignupCancel.css';

const SignupCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="signup-cancel-container">
      <div className="cancel-modal">
        <div className="cancel-icon">❌</div>
        <h2>Payment Cancelled</h2>
        <p>Your payment was cancelled. No charges have been made to your account.</p>
        
        <div className="cancel-message">
          <p>You can try again anytime or contact support if you need assistance.</p>
        </div>
        
        <div className="cancel-actions">
          <button 
            className="try-again-button"
            onClick={() => navigate('/')}
          >
            Try Again
          </button>
          <button 
            className="contact-support-button"
            onClick={() => window.open('mailto:support@bullbearly.com', '_blank')}
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupCancel;
